import ContractsRequests from '../../server/contracts';

export const setContracts = contracts => ({
  type: 'GET_USERS_CONTRACTS',
  contracts,
});


export const getContracts = clientId => async (dispatch) => {
  const contracts = await ContractsRequests.getContracts(clientId);
  dispatch(setContracts(contracts));
};

export default {
  getContracts,
};
